import { isVoltronEnabled } from 'owa-capabilities-definitions/lib/isVoltronEnabled';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Whether the Copilot pane should host the Outlook Copilot SDX. Read by the pane container, pane
 * header, and drawer so the SDX-owns-the-chrome decision stays consistent across all three - the
 * flag was previously spelled out at each site and drifted.
 */
export function isOutlookAgentSdxActive(mailboxInfo: MailboxInfo): boolean {
    return isVoltronEnabled(mailboxInfo);
}
